import {
  deleteSearchParams,
  replaceHistoryState,
} from '@/helpers/locationHelpers';
import {
  campaignTracking,
  setCampaignAffiliateToLocalstorage,
} from 'common/campaignTracking';
import cookieCommons from 'common/cookieCommons';
import { useEffect } from 'react';

const CampaignTrackingMetrics = () => {
  useEffect(() => {
    const { newPathname, searchKeyValue: ref } = deleteSearchParams('ref');

    //not need to track visit from owner
    if (ref) {
      const accessToken = cookieCommons.getAccessToken();
      //a.k.a user already loginned
      if (!accessToken) {
        setCampaignAffiliateToLocalstorage(ref as string);
      }
      campaignTracking({ campaignId: ref as string });
      replaceHistoryState(newPathname);
    }
  }, []);

  return <></>;
};

export default CampaignTrackingMetrics;
